"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feature = void 0;
const Projection_1 = require("./Projection");
class Feature {
    constructor(id, extent, geometry, properties) {
        this.loadGeometry = () => {
            if (typeof this.geometry.loadGeometry === 'function') {
                return this.geometry.loadGeometry();
            }
            else {
                return [[this.geometry]];
            }
        };
        this.toGeoJSON = (x, y, z) => {
            let geometry;
            if (typeof this.geometry.toGeoJSON === 'function') {
                geometry = this.geometry.toGeoJSON(this.extent, x, y, z);
            }
            else {
                const projection = new Projection_1.Projection(this.extent, x, y, z);
                const projected = projection.project([this.geometry]);
                geometry = {
                    "type": "Point",
                    "coordinates": projected[0]
                };
            }
            return {
                type: "Feature",
                id: Number(this.id),
                geometry: geometry,
                properties: this.properties
            };
        };
        this.id = id;
        this.geometry = geometry;
        this.properties = properties;
        this.extent = extent;
    }
}
exports.Feature = Feature;
//# sourceMappingURL=Feature.js.map